import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Textarea } from '../ui/Textarea';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
export function Step8Goals() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-496">
      <MascotPanel message="Een mooie website is leuk, maar hij moet vooral resultaat opleveren. Wat is het belangrijkste doel van uw nieuwe website?" data-id="element-497" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-498">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-499">Website Doelen</h2>

        <div data-id="element-500">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-501">
            Wat is het primaire doel van de website?
          </label>
          <RadioGroup columns={1} value={data.mainGoal} onChange={val => updateData({
          mainGoal: val
        })} options={[{
          value: 'leads',
          label: 'Leads genereren (offerte aanvragen, contactopnames)'
        }, {
          value: 'sales',
          label: 'Directe verkoop (webshop, online boekingen)'
        }, {
          value: 'info',
          label: 'Informatievoorziening (online visitekaartje, portfolio)'
        }, {
          value: 'support',
          label: 'Klantenservice (FAQ, handleidingen, portaal)'
        }, {
          value: 'employer',
          label: 'Personeel werven (vacatures, employer branding)'
        }, {
          value: 'other',
          label: 'Anders...'
        }]} data-id="element-502" />

          <AnimatePresence data-id="element-503">
            {data.mainGoal === 'other' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="mt-4 overflow-hidden" data-id="element-504">
                <Input placeholder="Vul hier uw primaire doel in..." value={data.mainGoalOther} onChange={e => updateData({
              mainGoalOther: e.target.value
            })} data-id="element-505" />
              </motion.div>}
          </AnimatePresence>
        </div>

        <Textarea label="Wat is de belangrijkste actie die een bezoeker moet ondernemen?" infoTooltip="De Call-To-Action (CTA). Bijv: 'Een afspraak inplannen', 'Een product kopen', of 'Bellen'." placeholder="Bijv. Het invullen van het contactformulier..." value={data.visitorAction} onChange={e => updateData({
        visitorAction: e.target.value
      })} data-id="element-506" />

        <Textarea label="Wie is uw ideale doelgroep?" placeholder="Beschrijf uw ideale klant (leeftijd, branche, problemen die ze ervaren)..." value={data.targetAudience} onChange={e => updateData({
        targetAudience: e.target.value
      })} data-id="element-507" />
      </div>
    </motion.div>;
}